import { Api } from 'models/services/api';
import { DeleteSatelliteKitchenQuery } from 'models/services/graphql';

import { SatelliteKitchenData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteSatelliteKitchen($id: ID!) {
    ${DeleteSatelliteKitchenQuery}
  }
`;

type ResponseData = {
  data: {
    deleteSatelliteKitchen: SatelliteKitchenData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: SatelliteKitchenData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteSatelliteKitchen;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };